/** API/URL 월 값을 `YYYY-MM` 형식으로 통일 */
export function normalizeSlaMonthKey(month) {
    if (month == null || month === "") return "";
    const text = String(month).trim();

    const fullMatch = text.match(/^(\d{4})-(\d{1,2})$/);
    if (fullMatch) {
        return `${fullMatch[1]}-${String(fullMatch[2]).padStart(2, "0")}`;
    }

    const compactMatch = text.match(/^(\d{4})(\d{2})$/);
    if (compactMatch) {
        return `${compactMatch[1]}-${compactMatch[2]}`;
    }

    return text;
}

export function findSlaMonthData(data, monthId) {
    const normalizedId = normalizeSlaMonthKey(monthId);
    if (!normalizedId || !Array.isArray(data)) return undefined;

    return data.find((item) => normalizeSlaMonthKey(item?.month) === normalizedId);
}

/** 모달 제목 — `2026년 1월 SLA 지표` */
export function formatSlaEditorTitle(month, monthLabel) {
    const normalized = normalizeSlaMonthKey(month);
    if (normalized) {
        const [year, monthNum] = normalized.split("-").map(Number);
        if (year && monthNum) {
            return `${year}년 ${monthNum}월 SLA 지표`;
        }
    }

    if (monthLabel) {
        const match = String(monthLabel).match(/(\d{4})\D+(\d{1,2})/);
        if (match) {
            return `${match[1]}년 ${Number(match[2])}월 SLA 지표`;
        }
    }

    return "SLA 지표";
}

/** `YYYY-MM` 기준 이전 달 */
export function getPreviousMonthKey(month) {
    const normalized = normalizeSlaMonthKey(month);
    const match = normalized.match(/^(\d{4})-(\d{2})$/);
    if (!match) {
        return null;
    }

    let year = parseInt(match[1], 10);
    let monthNum = parseInt(match[2], 10) - 1;

    if (monthNum < 1) {
        year -= 1;
        monthNum = 12;
    }

    return `${year}-${String(monthNum).padStart(2, "0")}`;
}
